import React from "react";

const AccountDetailsOverview: React.FC<{}> = (props) => {
	return <div></div>;
};

export default AccountDetailsOverview;
